//Comentario necesario para codificación en UTF-8, ver Inc6743
angular.module('pphhApp')
	.controller("pphhManagementController", ["$scope", "$window","$mdDialog", "CommonCatalogService", "pphhEnv",
		WaterModuleManagementController]);

function WaterModuleManagementController($scope, $window, $mdDialog,commonCatalogService, pphhEnv) {

	$scope.waterModule = null;
	$scope.filterResults = [];

	$scope.init = init;
	$scope.doFilter = doFilter;
	$scope.viewCicloPlan = viewCicloPlan;
	$scope.backToModuleIndex = backToModuleIndex;
	$scope.showEditDialog = showEditDialog;
	

	function init(waterModule) {
		commonCatalogService.getWaterModule(waterModule)
			.then(function(response) {
				$scope.waterModule = response.data;
				$scope.doFilter();
			});
	}

	function doFilter() {
		if (!$scope.waterModule) {
			return;
		}

		commonCatalogService.getVersions($scope.waterModule.key)
			.then(
				function(response) {
					$scope.filterResults = response.data;
				},
				function() {
					$mdDialog.show(
						$mdDialog.alert({
							title: UIMessages.dialog.confirm.title,
							textContent: "Error get",
							ok: UIMessages.dialog.confirm.cerrar
						}));
				}
			);
	}

	function viewCicloPlan(row) {
		$window.location.href = pphhEnv.global.contextPath + "/pphhNav-init"
			+ "?cicloId=" + row.id
			+ "&module=" + $scope.waterModule.key;
	}

	function backToModuleIndex() {
		$window.location.href = pphhEnv.global.contextPath + "/modules/index?directive=" + $scope.waterModule.directive.name;
	}

	//03956 Modificacion de nombre y descripcion de la version
	function showEditDialog(versionId) {
		$mdDialog.show({
			clickOutsideToClose: true,
			escapeToClose: true,
			parent: angular.element(document.body),
			locals: {
				inParams:{
					cicloId:versionId,
					module: $scope.waterModule.key
				} 
			},
			controller: "versionEditDialogController",
			templateUrl: "/pphh-sgpusa-versionEditDialog"
		}).then(function() {	
				$scope.doFilter();				
			}, function () {
				$scope.doFilter();
			});

	}
}
